<template>
  <div :id="'cont_' + formProperty.nativename" :class="getCompCSS(volatile)">
    <!--            value: '{{ value }}', valueDisp: '{{ valueDisp }}'<br/>-->
    <!--    formProperty.value: '{{ formProperty.value }}', formProperty.propertyInstanceValue: '{{ formProperty.propertyInstanceValue }}'<br/>-->
    <!--    filterOptions: {{filterOptions}}-->
    <!-- radio button mode -->
    <q-field v-if="formProperty.valuelistRendermode === 3" filled :hint="getHint()" :model-value="value" :label="getTitle()" stack-label hide-hint :class="formProperty.cssClass"
             :error-message="formProperty.errorMsg" :error="formProperty.errorMsg!==''" :dense="volatile || compressed">
      <template #control>
        <q-radio v-model="value" v-for="opt in selectOptions" :val="opt.value" :label="opt.label" class="q-mr-md q-mt-xs"
                 @update:model-value="onChange" dense size="xs" :key="opt.value" :disable="readOnly || formProperty.readonly"/>
      </template>
    </q-field>

    <!-- normal listbox -->
    <q-select v-else-if="!formProperty.valueListQueryID"
              :label="getTitle()"
              v-model="value"
              @update:model-value="onChange"
              @filter="filterFn"
              @input-value="onTyping"
              @blur="!formProperty.valuelistStrict?onBlur():''"
              @clear="this.value='';this.valueDisp='';onChange"
              :options="filterOptions" map-options
              :use-input="userInputAllowed()"
              :multiple="isMultipleSelect()"
              :max-values="formProperty.valuelistPicMax"
              :hide-selected="userInputAllowed() && !isMultipleSelect()"
              :fill-input="userInputAllowed() && !isMultipleSelect()"
              :use-chips="isMultipleSelect()"
              :placeholder="formProperty.infoTextHint" :readonly="showSpinner || formProperty.readonly || selectOptions.length===0 || readOnly"
              :loading="showSpinner" :class="'fld' + formProperty.nativename + ' ' + formProperty.cssClass"
              option-value="value" bottom-slots filled :hint="getHint()"
              :id="formProperty.nativename" :ref="formProperty.nativename" emit-value
              :error="formProperty.errorMsg!==''" :error-message="formProperty.errorMsg"
              input-debounce="0" :clearable="userInputAllowed()" :dense="volatile || compressed" :options-dense="volatile || compressed"
    >

      <template v-slot:selected-item="scope" v-if="!isMultipleSelect()">
        <div v-if="scope.opt.description && !Array.isArray(value)">
          <div class="q-pt-xs text-bold" v-html="Array.isArray(value)?scope.opt.label + '; ':scope.opt.label"/>
          <div class="text-grey-9" v-html="scope.opt.description"/>
        </div>
        <div v-else v-html="Array.isArray(value)?scope.opt.label + '; ':scope.opt.label"/>
      </template>

      <template #option="scope">
        <q-item class="q-pt-sm" v-bind="scope.itemProps"> <!-- v-on="scope.itemProps" -->
          <q-item-section>
            <q-item-label v-html="scope.opt.label"/>
            <q-item-label caption>{{ scope.opt.description }}</q-item-label>
          </q-item-section>
        </q-item>
      </template>
    </q-select>

    <!-- subquery field representation -->
    <div v-else @click="formProperty.valuelistStrict?openQueryPopupDlg():''">
      <q-field :readonly="true" :label="getTitle()" :dense="volatile || compressed" borderless filled stack-label v-model="valueDisp"
               bg-color="grey-1" :hint="getHint()"
               :error="formProperty.errorMsg!==''" :error-message="formProperty.errorMsg"
               :class="'cursor-pointer fldSelQuery ' + formProperty.cssClass"
      >
        <template v-slot:control>
          <div v-html="valueDisp" class="q-mt-xs"/>
        </template>
        <template #append v-if="!readOnly && !formProperty.readonly">
          <q-icon name="more_horiz" @click="showValueListQueryDlg=true" class="cursor-pointer"/>
          <q-icon name="cancel" @click.stop="clearSubQuery" class="cursor-pointer"/>
        </template>
      </q-field>
    </div>

    <!-- dialog for subquery form a ValueListQuery - opens other query and selected row is given as value -->
    <q-dialog v-model="showValueListQueryDlg" v-if="showValueListQueryDlg" :maximized="$q.platform.is.mobile" transition-show="slide-up" transition-hide="slide-down"> <!-- :persistent="$q.platform.is.safari" -->
      <q-card :style="!$q.platform.is.mobile?'min-width:90vw;max-width:90vw':''">
        <q-card-section :style="$q.platform.is.mobile?'min-height:82vh;max-height: 82vh':'min-height:82vh;max-height: 82vh'" class="scroll q-pb-none">
          <Query :qryID="formProperty.valueListQueryID" :embedProp="true" :name="'cmpQuery_' + formProperty.id"
                 suppressViewModeToggle clear :detailQueryKeyValue="buildParameterOfDefaultValueForSubquery()"
                 :showActions="false" stickyCSS="stickyTop" :doAutorefresh="false" @selectSingleQueryRow="(data)=>valueListQueryRow=data"/>
        </q-card-section>
        <q-separator/>
        <q-card-actions align="right" class="q-mt-xs">
          <q-btn label="Abbrechen" color="grey" flat v-close-popup/>
          <q-btn color="primary" :disable="!(valueListQueryRow && valueListQueryRow.row)" @click="btnValueListQueryOK" unelevated label="Auswählen" v-close-popup/>
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="showPopupDlg" :maximized="$q.platform.is.mobile" transition-show="slide-up" transition-hide="slide-down"> <!-- :persistent="$q.platform.is.safari" -->
      <q-card :style="!$q.platform.is.mobile?'min-width:90vw;max-width:90vw':''">
        <q-card-section class="row items-center q-pb-none">
          <q-space/>
          <q-btn icon="close" flat round dense v-close-popup/>
        </q-card-section>
        <q-card-section :style="$q.platform.is.mobile?'min-height:92vh;max-height: 92vh':'min-height:82vh;max-height: 82vh;margin-top:-50px'" class="scroll q-pb-none">
          <Formular :propObjClassID="value ? value.replace('formular://',''):''" :propSelectedRow="getParentFieldValues()" :propAppMode="true" @onFormularPersisted="inlineFormularPersisted"/>
        </q-card-section>
        <q-separator/>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import {getValueOrCleanNull} from './formsHelper'

import {fldComponentsMixin} from './mixins/fldComponent'
import {StaticData} from '../../classes/StaticData'
import {setCssVar} from 'quasar'
import OcrComp from "components/tech/ocr-comp.vue";
import Formular from "components/Formular.vue";
import {readonly} from "vue";
import {useAuthStore} from 'src/stores/AuthStore.js'

export default {
  name: "fldValueList",
  mixins: [fldComponentsMixin],
  props: [
    'queryID',
    'formProperty',
    'volatile',
    'selectedRow',
    'compressed',
    'formularList',
    'readOnly'
  ],
  components: {
    Formular
  },
  data() {
    return {
      StaticData,
      value: null,
      othervalue: "",
      valueDisp: "",  // used for subquery datatype
      selectOptions: [],
      showSpinner: false,
      filterOptions: [],
      showValueListQueryDlg: false,
      valueListQueryRow: null,
      typingBuffer: null,
      refreshToken: null,
      showPopupDlg: false
    }
  },

  watch: {
    value: function () {
      if (!this.formProperty.valueListQueryID) {
        if (this.value instanceof Array) this.formProperty.value = this.value.length > 0 ? this.value.join(";") : null
        else this.formProperty.value = this.value
      } else {
        // for subquery: value format is displaytext||value
        if (this.formProperty.valuelistDisplayField === "") this.formProperty.value = this.value
        else if (this.formProperty.valuelistDataField === "") this.formProperty.value = this.valueDisp
        else if (this.formProperty.valuelistDataField === this.formProperty.valuelistDisplayField) this.formProperty.value = this.value
        else {
          if (this.value != null) this.formProperty.value = this.valueDisp + "||" + this.value
          else this.value = null
        }
        //logger.info("Watcher value: ", this.formProperty.value, this.formProperty.valuelistDisplayField , this.formProperty.valuelistDataField)
      }
      // }
    },
    'formProperty.value'(newValue) {
      try {
        if (this.formProperty.valueListQueryID) {
        } else {
          if (this.formProperty.valuelistPicMax > 1) {
            if (newValue && !(newValue instanceof Array)) {
              this.value = newValue.split(";")
            } else {
              this.value = newValue
            }
          } else {
            this.value = this.getValueFromDisplayname(newValue)
          }
        }
      } catch (e) {
        logger.info("FEHLER bei watcher: ", this.formProperty.nativename, ", newValue:", newValue)
      }
    }
  },
  methods: {

    openQueryPopupDlg() {
      if (!this.readOnly && !this.formProperty.readonly) {
        this.showValueListQueryDlg = true
        this.valueListQueryRow = null
      }
    },

    filterFn(val, update) {
      update(() => {
        if (val === '') {
          this.filterOptions = [...this.selectOptions]
        } else {
          const needle = val.toLowerCase()
          this.filterOptions = this.selectOptions.filter(option =>
            option.label?.toLocaleLowerCase().includes(needle)
          )
        }
      })
    },

    /*    getSelectedItemLabel(scope) {
          const rawValue =
            scope?.opt && typeof scope.opt === 'object'
              ? scope.opt.value
              : scope?.opt ?? scope?.value ?? (
              Array.isArray(this.value) && typeof scope?.index === 'number'
                ? this.value[scope.index]
                : null
            )

          console.log("rawValue: ", scope, rawValue)

          if (scope?.opt && typeof scope.opt === 'object' && scope.opt.label) {
            console.log("scope.opt.label: ", scope.opt.label)
            return scope.opt.label
          }

          const option = this.selectOptions.find(option => option.value === rawValue)
          if (option?.label) {
            console.log("option.label: ", option.label)
            return option.label
          }

          console.log("rawValue: ", rawValue)
          return rawValue ?? ''
        },*/

    getSelectOptions() {
      // logger.info("getSelectOptions for ", this.formProperty.title, "valueList is ", this.formProperty.valueList)
      let result = []
      if (this.formProperty.valueList) {
        let valueList = this.formProperty.valueList.replaceAll("//;", "0x3B") // manual encode ; so we can use it in declaration

        // check for this: eins;zwei;drei=eins;zwei;drei (happen when SQL result gives us csv list
        let valueParts = valueList.split("=")
        if (valueParts.length === 2 && valueParts[0] === valueParts[1] && valueParts[0].indexOf(";") !== -1) {
          valueList = valueParts[0]
        }

        let optionList = valueList.split(";")

        // Starmax AG 234|Zweite Zeile=1;  Microhopf  e.U|Zweite Zeile=2;Nadlinger|Zweite Zeile=3;Semmelle
        // Starmax AG 234|Zweite Zeile=1;
        // Ja (TR123\; € 100\; 30 kg);Nein
        optionList.forEach((option) => {
          option = option.replaceAll("0x3B", ";") // decode ; back
          result.push(this.splitOption(option))
        })
      }
      // console.log("getSelectOptions result: ", this.formProperty.title, result)
      return result
    },

    splitOption(option) {
      let item = option.split("=")
      let opt = {}

      let labelAndDesc = item[0].split("|")
      if (labelAndDesc.length > 1) {
        opt.description = labelAndDesc[1]
      }

      if (item.length > 1) {
        opt.label = labelAndDesc[0].trim()
        opt.value = item[1].trim()
      } else {
        opt.label = labelAndDesc[0].trim()
        opt.value = item[0].trim()
      }
      //logger.info("opt:", opt);
      return opt
    },

    userInputAllowed() {
      let result = false
      //logger.info("userInputAllowed:", this.formProperty)
      if (this.formProperty.valuelistStrict === false ||
        this.formProperty.projectionValuelistAutocomplete === true ||
        this.formProperty.autoComplete === true) {
        result = true
      }

      return result
    },

    isMultipleSelect() {
      return this.formProperty.valuelistPicMax > 1
    },

    onChange(value) {
      setTimeout(() => {
        this.formProperty.errorMsg = ""
        this.formProperty.valueListMountedValue = null

        this.setErrorBrandColor()

        if (value == null) {
          this.value = null
          this.formProperty.value = null
          //logger.info("set value to ''")

        } else {
          this.value = value
          this.formProperty.value = Array.isArray(value) ? value.join(";") : value
        }


        //logger.info("onChange of valuelist ", value)
        if (typeof this.value === "string" && this.value.startsWith("formular://")) {
          this.showPopupDlg = true

        } else {
          let deleteDependentFields = true
          if (this.formProperty.autoComplete) {
            // hack: radio button rendering!
            deleteDependentFields = false
          }

          setTimeout(() => {
            this.$emit('onChange', {
              classID: this.formProperty.classID,
              parentClassID: this.formProperty.parentFormPointer?.classID,
              id: this.formProperty.ID,
              nativename: this.formProperty.nativename,
              deleteDependentFields: true,
              value: this.formProperty.value
            })
            //logger.info("emit onChange valuelist:", this.formProperty.nativename, this.value)

            if (this.$route.name === StaticData.ROUTE_NAMES.FORMULAR) {
              this.eventBus.formularEdited()
            }

            if (this.volatile && (this.formProperty.instantRefresh || this.formProperty.instantRefresh === undefined)) {
              setTimeout(() => {
                this.$emit('onEnter')  // submit volatile parameters for immediate refresh
              }, 10)
            }

          }, 10)
        }
      }, 10)
    },

    btnValueListQueryOK() {
      if (this.valueListQueryRow != null) {
        let prevValue = this.value
        let primaryKey = null
        let rowValues = Object.values(this.valueListQueryRow.row)
        //let columns = Object.values(this.valueListQueryRow.columns)

        this.valueListQueryRow.columns.forEach((col, idx) => {
          if (col.primaryKey) primaryKey = rowValues[idx]
        })

        this.value = this.valueListQueryRow.row[this.formProperty.valuelistDataField]

        if (!this.value || this.value === "") {
          this.value = primaryKey
        }

        if (this.value !== prevValue) {
          this.formProperty.value = this.value
        }
        this.valueDisp = this.valueListQueryRow.row[this.formProperty.valuelistDisplayField]

        //this.showValueListQueryDlg = false
        this.formProperty.validate()

        // logger.info("btnValueListQueryOK", this.formProperty.title, this.value)
        this.$emit('onChange', {
          classID: this.formProperty.classID,
          parentClassID: this.formProperty.parentFormPointer?.classID,
          id: this.formProperty.ID,
          nativename: this.formProperty.nativename,
          deleteDependentFields: true,
          value: this.value
        })  // send onChange event to parent (formular or parameter)
      }
    },

    onBlur() {
      //logger.info("onBlur valuelist")
      if (this.typingBuffer && !this.volatile) {
        this.onChange(this.typingBuffer)
      }
      this.typingBuffer = null
    },

    onTyping(value) {
      this.typingBuffer = value
    },

    clearSubQuery(event) {
      try {
        event.preventDefault()
      } catch (e) {
      }
      this.clear()
      this.$emit('onChange', {
        classID: this.formProperty.classID,
        parentClassID: this.formProperty.parentFormPointer?.classID,
        id: this.formProperty.ID,
        nativename: this.formProperty.nativename,
        deleteDependentFields: true,
        value: this.value
      })  // send onChange event to parent (formular or parameter)
    },

    getValue() {
      const authStore = useAuthStore()
      let result = this.formProperty.value
      if (this.formProperty.valueListQueryID) result = this.getValueForPopupSubquery(this.formProperty.value)

      /*
            if(this.formProperty.nativename === "partnerID"){
              console.log("getValue start partnerID:" + result)
            }
            if(this.formProperty.nativename === "partnerID2"){
              console.log("getValue start partnerID2:" + result)
            }
      */


      let propertyName = this.formProperty.name ? this.formProperty.name : this.formProperty.nativename
      let storedValue = localStorage.getItem(this.queryID + "__" + propertyName)
      let deepLinkParamValue = authStore.queryParamListFromDeepLink[this.formProperty.nativename]
      //console.warn("use stored value!:", storedValue)

      if (deepLinkParamValue) {
        if (this.formProperty.valueListQueryID) this.formProperty.value = this.getValueForPopupSubquery(deepLinkParamValue)
        else this.formProperty.value = this.splitOption(deepLinkParamValue).value
        result = this.formProperty.value

      } else if (storedValue != null) {
        result = storedValue
        this.formProperty.value = getValueOrCleanNull(storedValue, this.formProperty)

      } else if (!this.formProperty.value && this.formProperty.defaultValue) {
        if (this.formProperty.valueListQueryID) this.formProperty.value = this.getValueForPopupSubquery(this.formProperty.defaultValue)
        else this.formProperty.value = this.splitOption(this.formProperty.defaultValue).value
        result = this.formProperty.value
      }

      result = this.getValueFromDisplayname(result)

      // logger.info("getValue for ", this.formProperty.title, "=", result, this.selectOptions)
      if (this.formProperty.valuelistPicMax > 1 && result) {
        let tmpList = []
        let resultLst = result.split(";")
        resultLst.forEach(token => tmpList.push(token))
        result = tmpList
      }

      // autoselect first option if flag is set
      if (!result && this.selectOptions.length >= 1 && this.formProperty.valuelistAutoSelectFirst) {
        result = this.selectOptions[0].value
      }

      if (this.isMultipleSelect() && !result) {
        result = null
      }

      this.formProperty.value = result
      /*
            if(this.formProperty.nativename === "partnerID") console.log("getValue result partnerID:" + result)
            if(this.formProperty.nativename === "partnerID2") console.log("getValue result partnerID2:" + result)
      */

      return result
    },

    getLabelForPopupSubquery(value) {
      if (!value) return null
      let result = null

      let sqDefaultValueTokenList = value.split("||")
      //logger.info("getLabelForPopupSubquery BEFORE:", value, sqDefaultValueTokenList.length)
      switch (sqDefaultValueTokenList.length) {
        case 0:
          result = value
          break
        case 1:
          result = sqDefaultValueTokenList[0]
          break
        case 2:
          result = sqDefaultValueTokenList[0]
          break
      }
      //logger.info("getLabelForPopupSubquery AFTER:", result == null)
      if (result == "null") result = null

      return result
    },

    getValueForPopupSubquery(value) {
      if (!value) return null
      let result = null
      let sqDefaultValueTokenList = value.split("||")

      switch (sqDefaultValueTokenList.length) {
        case 0:
          this.valueDisp = value
          result = value
          break
        case 1:
          this.valueDisp = sqDefaultValueTokenList[0]
          result = sqDefaultValueTokenList[0]
          break
        case 2:
          this.valueDisp = sqDefaultValueTokenList[0]
          result = sqDefaultValueTokenList[1]
          break
      }

      //logger.info("getValueForPopupSubquery:", result)
      if (result === "null") result = null

      return result
    },

    getValueFromDisplayname(pValue) {
      if (pValue instanceof Array) return pValue

      // value can be a label when it comes as prefill from a queryaction.
      // now we look for the value to the label in our selectedOptions
      if (pValue && pValue.length > 0) {
        let myVal = pValue.toLowerCase().trim()

        let checkPattern = false

        if (this.isNumeric(myVal)) {
          return pValue
        }

        if (myVal.charAt(0) === '%') {
          checkPattern = true
          myVal = myVal.substr(1)
        }
        if (myVal.charAt(myVal.length - 1) === '%') {
          checkPattern = true
          myVal = myVal.substring(0, myVal.length - 1)
        }


        for (let i = 0; i < this.selectOptions.length; i++) {
          //logger.info("getValFromDispName: '" + this.selectOptions[i].label.toLowerCase().trim() + "' == '" + myVal + "'")

          //if (this.selectOptions[i].label.toLowerCase().trim().startsWith(myVal)) {
          if (this.selectOptions[i].label.toLowerCase().trim() === myVal || myVal === "") {
            // console.log("getValFromDispName: ", this.formProperty.title, "'" + this.selectOptions[i].label.toLowerCase().trim() + "' == '" + myVal + "'")
            pValue = this.selectOptions[i].value
            //logger.info("found value per label from prefill!")
            break
          } else if (checkPattern) {
            if (this.selectOptions[i].label.toLowerCase().trim().indexOf(myVal) !== -1) {
              pValue = this.selectOptions[i].value
            }
          }
        }

      }
      return pValue
    },

    isNumeric(str) {
      // Eliminiert Strings, die leer sind oder nur aus Leerzeichen bestehen
      if (typeof str != "string" || str.trim() === '') return false;

      // Prüft, ob der String eine Zahl mit parseFloat ist und ob er nicht unendlich ist
      return !isNaN(str) && !isNaN(parseFloat(str));
    },

    onRefreshValueList(data) {
      // logger.info("onRefresh for:", data.nativename, this.formProperty.parentFormPointer?.classID, '===', data.parentClassID)

      if (this.formProperty.parentFormPointer?.classID == data.parentClassID && (data.subtypeCount === undefined || data.subtypeCount === this.formProperty.subtypeCount) &&
        this.formProperty.nativename === data.nativename) {

        // logger.info("onRefresh for:", data.nativename, ' --- all in')

        if (data.nativename === 'assigned_partner_id') console.log("fond assigned_partner_id - isParameter: ", this.formProperty.isParameter, ', isEventFromParameter:', data.isEventFromParameter)

        if (data.isEventFromParameter && !this.formProperty.isParameter) return

        let myDepToken = this.formProperty.fieldDependencies ? this.formProperty.fieldDependencies.split(";") : ''
        //logger.info("data.sourceChangedNativename:", data.sourceChangedNativename)

        /*

                        logger.info("sourceChangedNativename:", data.sourceChangedNativename)
                        logger.info("myDepToken:", myDepToken)
                        logger.info("data", data)
                        logger.info("this.formProperty", this.formProperty)
        */


        // this component instance is a dependent field of changed field?
        // !data.sourceChangedNativename is undefined when it comes from parameter
        if (!data.sourceChangedNativename || myDepToken.includes(data.sourceChangedNativename)) {
          // logger.info("REFRESH valuelist:", this.formProperty.title, ", Token:", myDepToken, ", Data:", data)

          //logger.info("data.sourceChangedNativename:", data.sourceChangedNativename, "==", myDepToken)
          this.formProperty.valueList = data.value
          this.selectOptions = this.getSelectOptions()
          this.filterOptions = this.selectOptions

          // set default value from compValueChange (defaultValue of field or returned from compValueChange)
          let myfilter = this.selectOptions.filter(option => option.label.includes(data.defaultValue) || option.value.includes(data.defaultValue))

          if (myfilter.length > 0) {
            if (this.value instanceof Array && data.defaultValue) {
              let tmpList = []
              let resultLst = data.defaultValue.split(";")
              resultLst.forEach(token => tmpList.push(token))
              this.formProperty.value = tmpList
            } else this.value = data.defaultValue
          } else {
            this.value = null
          }

          // if (data.nativename == 'vh_tru_device_serie') logger.info("onRefreshValueList ", data.nativename, " - value:", this.value, data)

          // autoselect first option - if only one exists
          if ((!this.value || this.value == "") && this.selectOptions.length == 1) {
            // logger.info("AUTOSELECT first option. ", this.formProperty.title, "==", this.value)
            this.value = this.selectOptions[0].value
          }

          // value can be a label when it comes as prefill from a queryaction. now we look for the value to the label in our selectedOptions
          if (this.formProperty.valueListQueryID) {
            this.value = this.getValueForPopupSubquery(this.value)
            // if (data.nativename === 'assigned_comp_id') console.log("!!! value AFTER:" + this.value)

          } else {
            this.value = this.getValueFromDisplayname(this.value)
            this.valueDisp = this.value
            this.formProperty.value = this.value
          }

          // logger.info("REFRESH: ", this.formProperty.title, "=", this.value, "=", this.formProperty.value, ", valueDisp:", this.valueDisp)

          if (this.formProperty.instantRefresh &&
            (this.formProperty.renderOnFrontend && (this.formProperty.showThroughDependency === true || this.formProperty.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE))) {
            //logger.info("cascade onChange ongoing from ", this.frmProperty.title)
            //logger.info("emit onchange for ", this.formProperty.nativename)
            this.$emit('onChange', {
              classID: this.formProperty.classID,
              parentClassID: this.formProperty.parentFormPointer?.classID,
              id: this.formProperty.ID,
              nativename: this.formProperty.nativename,
              deleteDependentFields: true,
              value: this.value,
              sourceChangedNativename: data.sourceChangedNativename,
              cascadeResolved: data.cascadeResolved === true // server already resolved the cascade - no further compValueChange
            })  // send onChange event to parent (formular or parameter)

          } else {
            this.showSpinner = false
          }

          if (data.errorMsg) this.formProperty.errorMsg = data.errorMsg
          else this.formProperty.errorMsg = ""
          if (data.errorFetchingData) this.formProperty.errorFetchingData = data.errorFetchingData
          else this.formProperty.errorFetchingData = ""
        }

      }
      //this.$forceUpdate()
    },

    onShowSpinner(data) {
      //logger.info("valueList onShowSpinner.", data, this.formProperty, this.formProperty.id, "==", data.id)
      if (this.formProperty.id === data.id) {
        //if(data.id == '{53162A32-ED5B-11EA-8B3F-309C23AC5997}')
        //console.warn("onShowSpinner ", this.formProperty.title, data)
        this.showSpinner = data.spinnerOnOff
      }
    },

    onClearValueList(pevent) {
      if ((this.formProperty.nativename === pevent.nativename || pevent.nativename === "*")
        && this.formProperty.valuelistType === 2 && this.formProperty.dataTypeID === 201
        && (typeof pevent.subtypeCount === "undefined" || pevent.subtypeCount === this.formProperty.subtypeCount)) {

        if (pevent.nativename === "*" && pevent.sourceChangedNativename === this.formProperty.nativename) {
          return
        }

        // fieldDependencies are set in readFormularList in mp. Is a csv tokenliste of nativenames of dependent formularfields
        let myDepToken = this.formProperty.fieldDependencies ? this.formProperty.fieldDependencies.split(";") : ''
        //logger.info("onClearValueList with nativename ", this.formProperty.title, pevent.nativename, myDepToken, pevent.sourceChangedNativename, this.formProperty.valuelistType,this.formProperty.dataTypeID )
        //logger.info("onClearValueList:", this.formProperty.title, '(', this.formProperty.nativename, ') ', pevent.sourceChangedNativename, ', refreshToken=', this.refreshToken, '!=', pevent.guid)

        if (!pevent.guid) {
          pevent.guid = Math.random().toString(36).substr(2, 9)
        }

        // this component instance is a dependent field of changed field? - clear this component instance and cascade the clear.
        if (myDepToken.includes(pevent.sourceChangedNativename) && (this.refreshToken !== pevent.guid)) {
          this.refreshToken = pevent.guid

          this.clear()
          // cascade clear event to other valuelists which are perhaps dependent on this
          // console.log("cascade", this.formProperty.title)
          this.eventBus.clearValueListComp("*", "", this.formProperty.nativename, pevent.subtypeCount, pevent.guid)
        }
      }
    },

    onClearValuelistSelection(data) {
      if (this.formProperty.nativename === data.nativename && (typeof data.subtypeCount === "undefined" || data.subtypeCount === this.formProperty.subtypeCount)) {
        if (this.formProperty.valuelistPicMax > 1) {
          this.value = []
        } else {
          this.value = null
        }
      }
    },
    clear() {
      this.formProperty.valueList = this.formProperty.valuelistDefaultDomain
      this.value = null
      this.valueDisp = ""
      this.filterOptions = []
      this.selectOptions = []
      this.formProperty.value = null
    },

    getErrorLabel() {
      let result = ""
      if (this.formProperty.paramInfoRequired && this.formProperty.paramInfoRequired !== "") {
        result = this.formProperty.paramInfoRequired
      } else {
        result = "Feld muss befüllt werden."
      }
      return result
    },

    // build parameter default values for <query>
    // from selected row and defaultvalue of this valuelist (format: pname1=value1;pname2=value2;)
    buildParameterOfDefaultValueForSubquery() {
      let result = []

      for (let field in this.selectedRow) {
        let param = {name: field, value: this.selectedRow[field]}
        result.push(param)
      }

      this.formularList.forEach((formList, pageIndex) => {
        formList.formularFields.formularFlatList.forEach((field) => {
          let myfield = result.find(elem => {
            return elem.name === field.nativename
          })
          if (field.nativename === "cu_number") {
            logger.info("break")
          }

          if (myfield) {
            myfield.value = field.value
          } else {
            let param = {name: field.nativename, value: field.value}
            result.push(param)
          }
        })
      })

      return result
    },

    setErrorBrandColor() {
      try {
        if (this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY) {
          setCssVar('negative', '#f57c00', document.getElementById('cont_' + this.formProperty.nativename))

        } else {
          setCssVar('negative', '#c10015', document.getElementById('cont_' + this.formProperty.nativename))
        }
      } catch (e) {
        // console.error("Error setErrorBrandColor ", this.formProperty.title, e)
      }
    },

    validateStrictFieldValues(value) {
      if (this.formProperty.valuelistStrict && value && this.selectOptions.length > 0) {
        let found = false

        // todo: implement multiselect values
        if (typeof value != 'string') {
          return true;
        }
        let compValue = value.toLowerCase().trim()
        this.selectOptions.filter((opt) => {
          if (opt.label.toLowerCase().trim() === compValue || opt.value.toLowerCase().trim() === compValue) found = true
        })
        if (!found && (this.formProperty.defaultValue !== value) && !this.formProperty.valueListQueryID) {
          logger.info("error 'not part of list':", this.formProperty.title, ". value = '" + value + "', defaultValue='" + this.formProperty.defaultValue + "', selectOptions=", this.selectOptions)
          this.formProperty.errorMsg = "Ungültige bzw. veraltete Auswahl. Bitte aktuellen Wert aus der Liste wählen."
          this.formProperty.invalid = true
        }
      }
    },

    inlineFormularPersisted() {
      this.showPopupDlg = false

      this.$emit('onChange', {
        classID: this.formProperty.classID,
        parentClassID: this.formProperty.parentFormPointer?.classID,
        id: this.formProperty.ID,
        nativename: this.formProperty.nativename,
        deleteDependentFields: false,
        value: "new value"
      })  // send onChange event to parent (formular or parameter)
    },

    getParentFieldValues() {
      //logger.info("Call getParentFieldValues for field:", this.formProperty.title, this.formProperty)
      let result = {}
      if (this.formProperty.parentForm) {
        // logger.info("fldString:", this.formProperty.parentFormPointer.parentForm)
        this.formProperty.parentForm[0].formularFields.formularFlatList.forEach((field) => {
          // logger.info(field.nativename, '=', field.value)
          result[field.nativename] = field.value
        })
      }
      //logger.info("getParentFieldValues returns: ", result)
      return result
    },

    onAutocompleteApplyButton(data) {
      if (this.formProperty.nativename === data.nativename && (typeof data.subtypeCount === "undefined" || data.subtypeCount === this.formProperty.subtypeCount)) {
        this.value = data.value
        this.formProperty.value = data.value
        this.formProperty.errorMsg = ""
        this.formProperty.errorFetchingData = ""
        this.formProperty.invalid = false
        this.$forceUpdate()

        if (this.formProperty.instantRefresh && (this.formProperty.showThroughDependency === true || this.formProperty.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
          this.$emit('onChange', {
            classID: this.formProperty.classID,
            parentClassID: this.formProperty.parentFormPointer?.classID,
            id: this.formProperty.ID,
            nativename: this.formProperty.nativename,
            deleteDependentFields: true,
            value: this.value
          })  // send onChange event to parent (formular or parameter)
        } else {
          this.showSpinner = false
        }
      }
    }
  },

  beforeUnmount() {
    this.eventBus.off('onRefreshComp', this.onRefreshValueList)
    this.eventBus.off('onShowSpinner', this.onShowSpinner)
    this.eventBus.off('onClearValueList', this.onClearValueList)
    this.eventBus.off('onClearValuelistSelection', this.onClearValuelistSelection)
    this.eventBus.off('onAutocompleteApplyButton', this.onAutocompleteApplyButton)
  },

  mounted: function () {
    // console.log("mounted valuelist", this.formProperty.title, this.formProperty.nativename, this.formProperty.valuelistType, this.formProperty.valuelistPicMax)
    this.eventBus.on('onShowSpinner', this.onShowSpinner)
    this.eventBus.on('onRefreshComp', this.onRefreshValueList)
    this.eventBus.on('onClearValueList', this.onClearValueList)
    this.eventBus.on('onClearValuelistSelection', this.onClearValuelistSelection)
    this.eventBus.on('onAutocompleteApplyButton', this.onAutocompleteApplyButton)

    this.selectOptions = this.getSelectOptions()
    this.filterOptions = this.selectOptions

    this.value = this.getValue()
    /*    if (this.formProperty.nativename === "task_priority") {
          logger.info("task_priority: ", this.formProperty)
        }*/
    // this.formProperty.valueListMountedValue = value

    this.validateStrictFieldValues(this.value)

    // workaround while formProperty migration...
    if (
      !this.formProperty.valuelistMsgEmpty
    )
      this.formProperty.valuelistMsgEmpty = ""

    if (this.formProperty.valuelistMsgEmpty.trim() === "") {
      this.formProperty.valuelistMsgEmpty = "";
    }

    this.formProperty.validate = () => {
      this.formProperty.errorMsg = ""
      this.setErrorBrandColor()

      let value = this.value ? this.value : ""

      if (this.selectOptions.length === 0 && this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY && value === "") {
        //logger.info("validate empty lazy field  ", this.formProperty.title, this.selectOptions, value)
        this.formProperty.errorMsg = this.getErrorLabel()
        this.formProperty.invalid = true

      } else {
        if (this.formProperty.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
          if (((this.formProperty.valuelistPicMin && this.formProperty.valuelistPicMin > 0 && value === "") ||
            ((this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) && value === "")) && this.formProperty.showThroughDependency === true) {
            this.formProperty.errorMsg = this.getErrorLabel()
            this.formProperty.invalid = true
          } else {
            this.formProperty.invalid = this.formProperty.errorFetchingData !== "" // || this.getSelectOptions().length == 0
            this.formProperty.errorMsg = this.formProperty.errorFetchingData
          }

        } else {
          if (this.formProperty.valuelistRendermode === 3 && this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.NONE && value === "") {
            this.formProperty.errorMsg = ""
            this.formProperty.invalid = false
          } else if ((this.formProperty.valuelistPicMin && this.formProperty.valuelistPicMin > 0 && value === "") ||
            ((this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) && value === "")) {
            this.formProperty.errorMsg = this.getErrorLabel()
            this.formProperty.invalid = true
          } else {
            this.formProperty.invalid = this.formProperty.errorFetchingData !== "" // || this.getSelectOptions().length == 0
            this.formProperty.errorMsg = this.formProperty.errorFetchingData
          }
        }
        this.validateStrictFieldValues(value)
      }
    }

    this.formProperty.setValid = () => {
      this.formProperty.errorMsg = ""
      this.formProperty.invalid = false
    }

    this.formProperty.setError = (errMsg) => {
      let tmp = this.value
      this.value = null
      this.valueDisp = ""
      this.value = tmp // rerender field & errorstats
      this.formProperty.errorMsg = errMsg
      this.formProperty.invalid = true
    }

    //logger.info("this.formProperty.objInstanceID: ", this.formProperty.objInstanceID)

    // Trigger initial compValueChange event - so dependent fields can update (only when not preloaded with instances from oiID parameter)
    if (!this.formProperty.noInitOnChange && !this.formProperty.objInstanceID) {
      // logger.info("initial onChange for ", this.formProperty.title, ', objInstanceID: ', this.formProperty.objInstanceID, ', value:', this.value)

      // if (!this.formProperty.valueListQueryID) {
      this.$emit('onChange', {
        classID: this.formProperty.classID,
        parentClassID: this.formProperty.parentFormPointer?.classID,
        id: this.formProperty.ID,
        nativename: this.formProperty.nativename,
        deleteDependentFields: false,
        value: this.value,
        valueListMountedOnChange: true
      })
      // }
    }
  }
}
</script>

<style lang="sass">
.ipradio
  border-radius: 5px 5px 0 0

.fldSelQuery
  .q-field__native
    cursor: pointer !important

/*.dlgValueList
  margin-left: 45%
  max-width: 75% !important

  .q-field--dense .q-field__label
    top: 6px

  .q-field--dense
    font-size: 13px

  .q-field--dense .q-field__bottom
    padding-top: 2px*/
</style>
